"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core/");
var _Accordion = _interopRequireDefault(require("@material-ui/core/Accordion"));
var _AccordionSummary = _interopRequireDefault(require("@material-ui/core/AccordionSummary"));
var _AccordionActions = _interopRequireDefault(require("@material-ui/core/AccordionActions"));
var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));
var _lodash = require("lodash");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    headingStyle: {
      fontSize: "".concat(theme.typography.pxToRem(20), "!important"),
      letterSpacing: 1
    }
  };
});
var ExpansionPanel = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      boxShadow: 'none',
      backgroundColor: theme.palette.background.grey,
      '&:not(:last-child)': {
        marginBottom: '20px'
      },
      '&:before': {
        display: 'none'
      },
      '&$disabled': {
        backgroundColor: theme.palette.background.grey
      }
    },
    disabled: {}
  };
})(_Accordion.default);
var ExpansionPanelSummary = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      minHeight: 56,
      padding: 0,
      alignItems: 'center',
      '&$expanded': {
        minHeight: 56
      },
      '&$disabled': {
        opacity: '1'
      }
    },
    content: {
      margin: '16px 0',
      order: 1,
      paddingRight: '12px',
      '&$expanded': {
        margin: '16px 0'
      }
    },
    expanded: {},
    disabled: {},
    expandIcon: {
      order: 0,
      marginRight: 0,
      alignSelf: 'flex-start',
      top: theme.spacing(1.5),
      '&$expanded': {
        transform: 'rotate(90deg)'
      }
    }
  };
})(_AccordionSummary.default);
var ExpansionPanelDetails = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      paddingLeft: '48px',
      paddingRight: '48px',
      width: '100%',
      '&>div': {
        width: '100%'
      }
    }
  };
})(_AccordionActions.default);
var AccordionPanel = function AccordionPanel(_ref) {
  var expandedProps = _ref.expandedProps,
    headingElement = _ref.headingElement,
    content = _ref.content,
    faqContent = _ref.faqContent;
  var classes = useStyles();
  var theme = (0, _styles.useTheme)();
  var _React$useState = _react.default.useState((0, _lodash.uniqueId)('accordion-panel-')),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 1),
    uniqueId = _React$useState2[0];
  var Tag = headingElement;

  // apply schema props for FAQ
  var itemPropName = faqContent ? 'name' : undefined;
  var itemPropText = faqContent ? 'text' : undefined;
  var answer = {};
  if (faqContent) {
    expandedProps['itemProp'] = 'mainEntity';
    expandedProps['itemType'] = 'https://schema.org/Question';
    expandedProps['itemScope'] = true;
    answer['itemProp'] = 'acceptedAnswer';
    answer['itemType'] = 'https://schema.org/Answer';
    answer['itemScope'] = true;
  }
  return __jsx(ExpansionPanel, (0, _extends2.default)({
    square: true,
    "data-cmp-hook-accordion": "item"
  }, expandedProps), __jsx(ExpansionPanelSummary, {
    "data-cmp-hook-accordion": "button",
    "aria-controls": uniqueId,
    id: uniqueId,
    expandIcon: __jsx(_ChevronRight.default, {
      style: {
        color: theme.palette.secondary.main
      }
    })
  }, headingElement ? __jsx(Tag, {
    itemProp: itemPropName,
    className: headingElement,
    dangerouslySetInnerHTML: {
      __html: content.props['cq:panelTitle']
    }
  }) : __jsx(_core.Typography, {
    itemProp: itemPropName,
    variant: "h2",
    className: "".concat(classes.headingStyle, " fontStyleBolder"),
    style: {
      marginBottom: '0px'
    },
    dangerouslySetInnerHTML: {
      __html: content.props['cq:panelTitle']
    }
  })), __jsx(ExpansionPanelDetails, (0, _extends2.default)({
    "data-cmp-hook-accordion": "panel"
  }, answer), __jsx("div", {
    itemProp: itemPropText
  }, content)));
};
var _default = AccordionPanel;
exports.default = _default;